import React, { Component, createRef } from "react";
import {
  FixedWidth,
  DisplayFlex,
  BlurContainer,
  BlurOverlay,
  LinkTo
} from "../../../../CommonComponents/commonStyles";
import { Row, Col } from "antd";
import TableComponent from "../../Components/Table/Table";
import UserDetails from "../../Components/UserDetails/UserDetails";
import {
  BlockContainer,
  UserContributionDetails,
  UserDateDetails,
  ProfileSectionHeading,
  ProfileInformationHeading,
  ProfileBlockContainer,
  ProfileAddressContainer,
  AddressDetails,
  DetailsData,
  FirstColumn,
  SecondColumn,
  HorizontalDivider,
  IconContainer,
  DetailsContainer,
  DefaultIndicator,
  UserContributionContactDetails,
  SecurityDetailsAccess,
  SecurityAnswerAccess,
  ItemWrapper,
  InlineDiv
} from "../../styles";
import Phone from "../../../../assets/icons/phone.svg";
import Aggregator from "../../../../assets/icons/aggregator_leaf.svg";
import Email from "../../../../assets/icons/email.svg";
import Delivery from "../../../../assets/icons/delivery-preference.svg";
import Address from "../../../../assets/icons/addresses.svg";
import DBase from "../../../../assets/icons/db_icon.svg";
import Profile from "../../../../CommonComponents/svgs/Profile";
import Password from "../../../../assets/icons/password.svg";
import AccessKey from "../../../../assets/icons/access-key.svg";
import SecurityQuestion from "../../../../assets/icons/security-questions.svg";
import { isGeminiUser } from "../../../../utils/sessionUtil";
import WebRegisterComponent from "../../../../CSR/WebAccessContainer/WebRegisterComponent/WebRegisterComponent";
import _ from "lodash";
import {
 ContentMessage,
 Types
} from "../../../../CommonComponents/ContentMessages";
import PropTypes from 'prop-types';
import { isNewAdvent, sortAggrDates } from "../../utils";


class MyProfilePrint extends Component {    
  constructor(props) {
    super(props);
    this.state = {
      isBlurDisabled: true,
      countries: [],
      validKey: false
    }
  }


  componentDidMount() {    
    const { countries } = this.props;
    if(countries) this.setState({
      countries: countries
    });
  }

  toggleisEnabled = value => {
    this.setState({ isBlurDisabled: value });
  };

  getCountry(country_id) {
    if(this.state.countries.length > 0 && country_id) {
      let country = this.state.countries.find(item => item.value.toString() === country_id.toString());
      if(country) return country.desc;
    }

    return;
  }

  render() {
    const ref = createRef();

    const { profileData, accessKeyData, accessKeyExpiry } = this.props; 

    const { profileSummary } = this.props.profileData;
    const dataAggregators = sortAggrDates(profileSummary.dataAggregators);

    let numRows = profileSummary.address !== null ? Math.ceil(profileSummary.address.length/3): 0;

    let address = [];

    for(let i = 0; i < numRows; i++) {
      let start = i * 3;
      address.push({
        row: i + 1,
        addresses: profileSummary.address.slice(start, start + 3)
      })
    }    

    let accessKey = '';

    let date = new Date();

    let currTime = date.getTime();
    // Check Not web register
    const checkNotWebregister = () => _.isNull(profileData.webAccess)
    const checkLegacyRegister = () => {
      return !_.isNull(profileData.webAccess) && !_.isNull(profileData.webAccess.webRegistered) && !profileData.webAccess.webRegistered
    }

    if(profileData.webAccess && profileData.webAccess.accessKeyExpired === true){
      this.state.validKey = false; 
    } else if(!accessKeyExpiry && profileData.webAccess && profileData.webAccess.accessKeyValidTill && profileData.webAccess.accessKeyValidTill > currTime) {
      this.state.validKey = true;
      accessKey = profileData.webAccess.accessKey;
    }
    
    if(accessKeyExpiry && accessKeyExpiry > currTime) {
      accessKey = accessKeyData;
      this.state.validKey = true;
    }

    return (
      <div>
        <FixedWidth data-test="myProfilePrintBlock">
          <UserDetails
            profileData={profileData}
            isLoading={this.props.isLoading}
          />
          <BlurContainer ref={ref}>
            <BlurOverlay isEnabled={this.state.isBlurDisabled} />
            <BlockContainer>
            <div>
              <DisplayFlex>
                <ProfileSectionHeading>
                  <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Profile" property="field_type_1_title" defaultMessage="Contact Details" />
                </ProfileSectionHeading>
              </DisplayFlex>
              <Row>
                <FirstColumn lg={12} sm={12} xs={12}>
                  <DetailsContainer>
                    <IconContainer>
                      <img src={Phone} alt="Phone"/>
                    </IconContainer>{" "}
                    <DetailsData className="wrapContent">
                      <ProfileInformationHeading>
                        Phone Number
                      </ProfileInformationHeading>
                      {(this.props.profileData.profileSummary.phone!==null)?
                      
                      this.props.profileData.profileSummary.phone.map((obj,index) => {                 
                        return (
                          <UserContributionContactDetails data-test="ContactDetailsPhone" key={index}>
                            {obj.phoneType}:
                            <UserDateDetails>{obj.phone}</UserDateDetails>
                            {
                              obj.primary.toString() === "1"
                              && <DefaultIndicator>PRIMARY</DefaultIndicator>
                            }
                          </UserContributionContactDetails>
                        );
                      
                      }): '-'}
                    </DetailsData>
                  </DetailsContainer>
                  <DetailsContainer>
                    <IconContainer>
                      <img src={Email} alt="Email"/>
                    </IconContainer>
                    <DetailsData className="wrapContent">
                      <ProfileInformationHeading>Email</ProfileInformationHeading>
                      {(this.props.profileData.profileSummary.email!==null)?
                      
                      this.props.profileData.profileSummary.email.map((obj,index) => {                  
                          return (
                            <UserContributionContactDetails data-test="ContactDetailsEmail" key={index}>
                              {obj.emailType}:
                              <UserDateDetails>{obj.email}</UserDateDetails>
                              {
                                obj.primary.toString() === "1"
                                && <DefaultIndicator>PRIMARY</DefaultIndicator>
                              }
                            </UserContributionContactDetails>
                          );
                      }): "-"}
                    </DetailsData>
                  </DetailsContainer>
                    {dataAggregators && dataAggregators.length ?
                      (<DetailsContainer>
                        <IconContainer>
                          <img src={DBase} alt="db" />
                        </IconContainer>{" "}
                        <DetailsData className="wrapContent">
                          <ProfileInformationHeading className="myProfileFontFix">
                            Data Aggregator
                            {isNewAdvent(dataAggregators) ? (
                              <InlineDiv className="ml-03">
                                <img src={Aggregator} className="aggregator_icon" alt="aggregator" />
                                <span className="aggregator_newbtn">New</span></InlineDiv>) : <></>}
                          </ProfileInformationHeading>
                          <UserDateDetails>
                            <ItemWrapper>
                              {dataAggregators.map((agg, cnt) => {
                                if (dataAggregators.length - 1 === cnt) return agg.aggrName;
                                else return agg.aggrName + ', ';
                              })}
                            </ItemWrapper>
                          </UserDateDetails>
                        </DetailsData>
                      </DetailsContainer>) : <></>}
                  <DetailsContainer>
                    <IconContainer>
                      <img src={Delivery}alt="Delivery" />
                    </IconContainer>{" "}
                    <DetailsData data-test="DeliveryPreference" className="wrapContent">
                      <ProfileInformationHeading>
                        Delivery Preference
                      </ProfileInformationHeading>

                      <div>
                        <b>{this.props.profileData.profileSummary.deliveryPreference!==null?this.props.profileData.profileSummary.deliveryPreference: "-"}</b>
                      </div>
                    </DetailsData>
                  </DetailsContainer>
                </FirstColumn>
                <SecondColumn lg={12} sm={12} xs={12}>
                  <DetailsContainer>
                    <IconContainer>
                      <img src={Address} alt="Address"/>
                    </IconContainer>{" "}
                    <DetailsData>
                      <ProfileInformationHeading>Address</ProfileInformationHeading>
                      <ProfileBlockContainer>                  
                        {(address.length > 0)?
                          address.map((rowobj,index) => {
                            return (                                             
                              <Row data-test="AddressRow" key={index}>
                                {
                                  rowobj.addresses.map((obj,i) => {

                                    const count = profileSummary.address.length;
                          
                                    const lg =  count < 4 ? 24/count: 8;

                                    let addr = obj.addressLine1 ? obj.addressLine1: '';

                                    if(addr) addr = obj.addressLine2 ? `${addr}, ${obj.addressLine2}`: addr;

                                    else addr = obj.addressLine2 ? obj.addressLine2: '';

                                    if(addr) addr = obj.addressLine3 ? `${addr}, ${obj.addressLine3}`: addr;

                                    else addr = obj.addressLine3 ? obj.addressLine3: '';

                                    return(
                                      <Col key ={i} lg={lg} sm={24} xs={24}>
                                        <ProfileAddressContainer className="addrWrapper">
                                          <DisplayFlex>
                                            <UserContributionDetails>
                                              {obj.addressType}:
                                            </UserContributionDetails>
                                            {
                                              obj.primary.toString() === "1"
                                              && <DefaultIndicator>PRIMARY</DefaultIndicator>
                                            }
                                          </DisplayFlex>
                                          <AddressDetails>{addr}</AddressDetails>
                                          {
                                            obj.city
                                            && <AddressDetails>{obj.city}</AddressDetails>
                                          }
                                          {
                                            obj.state && obj.zipCode
                                            && <AddressDetails>{obj.state}, {obj.zipCode}</AddressDetails>
                                          }
                                          {
                                            obj.state && !obj.zipCode
                                            && <AddressDetails>{obj.state}</AddressDetails>
                                          }
                                          {
                                            !obj.state && obj.zipCode
                                            && <AddressDetails>{obj.zipCode}</AddressDetails>
                                          }                            
                                          {
                                            obj.country
                                            && <AddressDetails>{this.getCountry(obj.country)}</AddressDetails>
                                          }
                                        </ProfileAddressContainer>
                                      </Col>
                                    )
                                  })                             
                                }
                              </Row>
                            );   
                        }): "-" }                            
                      </ProfileBlockContainer>
                    </DetailsData>
                  </DetailsContainer>
                </SecondColumn>
              </Row>
              <HorizontalDivider />
            </div>
            </BlockContainer>
            <BlockContainer>
            { isGeminiUser() && checkNotWebregister() || checkLegacyRegister() ? <WebRegisterComponent profileData={profileData}/> :     
            <div>
              <ProfileSectionHeading data-test="ProfileSectionHeading">                
                <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Profile" property="field_type_2_title" defaultMessage="Web Access Information" />
              </ProfileSectionHeading>
              <Row>
                <FirstColumn lg={12} sm={12} xs={12}>
                  <DetailsContainer>
                    <IconContainer>
                      <Profile />
                    </IconContainer>
                    <DetailsData data-test="ProfileUserIdSection">
                      <ProfileInformationHeading>User ID</ProfileInformationHeading>
                      <UserContributionDetails>
                        {this.props.profileData.webAccess.userName}
                      </UserContributionDetails>
                      <span className="tool-tip">
                      <LinkTo>
                      <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Profile" property="field_type_4_title" defaultMessage="Update User ID" />
                      </LinkTo>
                  <span>
                    <span className="tooltiptext-i">Coming Soon...</span>
                  </span>
                </span>
                    </DetailsData>
                  </DetailsContainer>
                  <DetailsContainer>
                    <IconContainer>
                      <img src={Password} alt="Password"/>
                    </IconContainer>
                    <DetailsData data-test="ProfilePasswordSection">
                      <ProfileInformationHeading>Password</ProfileInformationHeading>
                      <UserContributionDetails>***********</UserContributionDetails>                
                      <LinkTo>
                      <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Profile" property="field_type_5_title" defaultMessage="Update Password" />
                      </LinkTo>
                    </DetailsData>
                  </DetailsContainer>
                  <DetailsContainer>
                    <IconContainer>
                      <img src={AccessKey} alt="AccessKey"/>
                    </IconContainer>
                    {
                      this.state.validKey && profileData.webAccess && profileData.webAccess.accessKeyLinked !== true
                      && <DetailsData data-test="ProfileAccessKey">
                          <ProfileInformationHeading>
                            Access Key
                          </ProfileInformationHeading>
                          
                              <UserContributionDetails>
                                <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page="My Profile" property="field_access_key_generated" defaultMessage="<p>The Access Key will expire four hours from the time that it is generated.</p>" />
                              </UserContributionDetails>
                              <LinkTo>
                                { accessKey }
                              </LinkTo>
                            
                        </DetailsData>
                    }
                    {
                      !this.state.validKey && profileData.webAccess && profileData.webAccess.accessKeyLinked !== true
                      && <DetailsData data-test="ProfileAccessKeyGenerate">
                          <ProfileInformationHeading>
                            Access Key
                          </ProfileInformationHeading>
                          <UserContributionDetails>
                            <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page="My Profile" property="field_access_key_not_generated" defaultMessage="<p>Click button below to generate your access key to link your Vanguard accounts.Once linked, you can initiate a contribution to Vanguard Charitable from vanguard.com.</p>" />
                          </UserContributionDetails>
                          <LinkTo >Generate</LinkTo>
                        </DetailsData>
                    } 

                    {
                      profileData.webAccess && profileData.webAccess.accessKeyLinked === true
                      && <DetailsData>
                          <ProfileInformationHeading>
                            Access Key
                          </ProfileInformationHeading>
                          <UserContributionDetails>
                          <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page="My Profile" property="field_access_key_linked" defaultMessage="<p>You have successfully linked your account.</p>" />
                          </UserContributionDetails>                      
                        </DetailsData>                
                    }
                    
                  </DetailsContainer>
                </FirstColumn>
                <SecondColumn lg={12} sm={12} xs={12} data-test="securityQuestionBlock">
                  <DetailsContainer>
                    <IconContainer>
                      <img src={SecurityQuestion} alt="Question"/>
                    </IconContainer>{" "}
                    <Row>
                      <ProfileInformationHeading>
                        Security Questions
                      </ProfileInformationHeading>

                      <SecurityDetailsAccess>
                        {this.props.profileData.webAccess.securityQuestions.question1}
                      </SecurityDetailsAccess>
                      <SecurityAnswerAccess>***********</SecurityAnswerAccess>
                      <SecurityDetailsAccess>
                        {this.props.profileData.webAccess.securityQuestions.question2}
                      </SecurityDetailsAccess>
                      <SecurityAnswerAccess>***********</SecurityAnswerAccess>
                      <SecurityDetailsAccess>
                        {this.props.profileData.webAccess.securityQuestions.question3}
                      </SecurityDetailsAccess>
                      <SecurityAnswerAccess>***********</SecurityAnswerAccess>
                      <SecurityDetailsAccess> 
                        <LinkTo>
                        <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Profile" property="field_type_6_title" defaultMessage="Change security questions" />
                        </LinkTo>           
                      </SecurityDetailsAccess>
                    </Row>
                  </DetailsContainer>
                </SecondColumn>
              </Row>
            </div>
            }
            </BlockContainer>
          </BlurContainer>
          <HorizontalDivider />
          <BlockContainer data-test="tableComponent">
            <DisplayFlex>
              <ProfileSectionHeading>                
                <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Profile" property="field_type_3_title" defaultMessage="Account Information" />
              </ProfileSectionHeading>              
            </DisplayFlex>
            <Row>                
              <TableComponent TableData={profileData.accountInformations} />
            </Row>            
          </BlockContainer>
        </FixedWidth>
        
      </div>
    );
  }
}

MyProfilePrint.propTypes = {
  profileData: PropTypes.object
}

export default MyProfilePrint;